import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";

class Logout extends React.Component {

    componentDidMount() {
        this.props.history.replace("/");
        this.props.logout();
    }

    render() {
        return <Fragment>
            I am the logout screen, you shouldnt be here
        </Fragment>;
    }

}

export default withRouter(Logout);